if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    setActiveMediaById(mediaId, scrollIntoView = true) {
      const targetMedia = this.querySelector(
        `[data-media-id="${mediaId}"], [data-product-media-id="${mediaId}"]`
      );
      if (!targetMedia || targetMedia.hidden || targetMedia.dataset.mediaVisible === 'false') return;

      this.querySelectorAll('[data-media-id].is-active, [data-product-media-id].is-active').forEach((element) => {
        element.classList.remove('is-active');
      });

      targetMedia.classList.add('is-active');
      if (scrollIntoView) {
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      const container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollLeft = Math.max((targetMedia.offsetWidth - container.clientWidth) / 2, 0);
      }

      if (targetMedia.nodeName == 'DEFERRED-MEDIA') {
        const activeMediaTemplate = targetMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          targetMedia.loadContent();
        }
      }
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      if (!mediaId) return;
      this.setActiveMediaById(mediaId, false);
    }
  });
}
